import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["column"]
  static values = { lostMessage: String }

  connect() {
    this.sortables = []
    this.columnTargets.forEach((column) => {
      const sortable = Sortable.create(column.querySelector("[data-kanban-cards]"), {
        group: "kanban",
        animation: 150,
        ghostClass: "opacity-30",
        dragClass: "shadow-xl",
        onEnd: this.onEnd.bind(this)
      })
      this.sortables.push(sortable)
    })
  }

  disconnect() {
    this.sortables.forEach((s) => s.destroy())
  }

  async onEnd(event) {
    const { item, to, from } = event
    if (to === from) return

    const quoteId = item.dataset.quoteId
    const newStatus = to.closest("[data-status]").dataset.status
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    try {
      const response = await fetch(`/quotes/${quoteId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ quote: { status: newStatus } })
      })

      if (!response.ok) throw new Error(String(response.status))

      this.updateCounters()
    } catch (error) {
      // Revert: move card back to original column
      from.appendChild(item)
      this.updateCounters()
      // Il 422 su "persa" è la validazione del motivo: la scheda dell'opportunità
      // ha i campi giusti, il drag no.
      if (error.message === "422" && this.hasLostMessageValue) {
        alert(this.lostMessageValue)
      }
    }
  }

  updateCounters() {
    this.columnTargets.forEach((column) => {
      const cards = column.querySelectorAll("[data-quote-id]")
      const count = cards.length
      let total = 0
      let weighted = 0
      cards.forEach((card) => {
        total += parseFloat(card.dataset.amount) || 0
        weighted += parseFloat(card.dataset.weightedValue) || 0
      })

      const formatEuro = (value) => new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value)

      const countEl = column.querySelector("[data-count]")
      const totalEl = column.querySelector("[data-total]")
      const weightedEl = column.querySelector("[data-weighted]")
      if (countEl) countEl.textContent = count
      if (totalEl) totalEl.textContent = formatEuro(total)
      if (weightedEl) weightedEl.textContent = formatEuro(weighted)
    })
  }
}
